<template lang="pug">
.no-use-container(v-if="show")
  .shadow(@click="closeModal")
  .no-use
    .no-use-top
      img.no-use-close(src="https://m.hellobike.com/resource/gallery/61/jnlkOWH5wR.png?x-oss-process=image/quality,q_80" @click="closeModal")
    .award-task-title
      .awad-task-img
        //- img.title-word(src="https://m.hellobike.com/resource/gallery/61/Fhjb_FDqD4.png?x-oss-process=image/quality,q_80")
      span 本周期已获得
      span.red-big-wrod {{ taskModalData.recordTotalReceiveBonusNum }}
      span.red-normal 个
    .award-task-container
      awardList.award-list(
        v-if="taskModalData.completeSingleTaskList"
        :awardList="taskModalData.completeSingleTaskList"
      )
      taskList.task-list(
        v-if="taskModalData.taskShowInfoList"
        :taskList="taskModalData.taskShowInfoList"
        :showAward="taskModalData.completeSingleTaskList?true:false"
      )

</template>
<script>
import {
  getNoScroll,
} from '@/utils';
import awardList from './award-list.vue';
import taskList from './task-list.vue';

export default {
  components: {
    awardList,
    taskList,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    propVersion: {
      type: String,
      default: '',
    },
    vipRecordGuid: {
      type: String,
      default: '',
    },
    taskModalData: {
      type: Object,
      default() {
        return {
          recordTotalReceiveBonusNum: 0,
          campaignInfoDTOS: [],
          taskShowInfoList: [],
        };
      },
    },
  },
  data() {
    return {
      taskList: [],
    };
  },
  watch: {
  },
  destroyed() {
  },
  created() {
  },
  methods: {
    closeModal() {
      this.$emit('update:show', false);
      getNoScroll(false);
    },
  },
};
</script>
<style lang="less" scoped>
.no-use-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 222;

  .no-use {
    // background-image: url(https://m.hellobike.com/resource/gallery/61/nuOIKC2yi2.png?x-oss-process=image/quality,q_80);
    background-size: 100% 100%;
    position: relative;
    z-index: 223;
    height: 4.98rem;
    padding-bottom: 0.2rem;

    .no-use-top {
      img.no-use-close {
        position: absolute;
        top: 0.26rem;
        right: 0.16rem;
        height: 0.16rem;
        width: 0.16rem;
      }
    }

    .award-task-title {
      display: flex;
      padding: 0.23rem 0 0 0.26rem;
      padding-left: 1.4rem;
      font-family: PingFang SC;
      font-size: 0.12rem;
      font-weight: 400;
      line-height: 0.38rem;
      background: url(https://m.hellobike.com/resource/gallery/30/RkWHPtCp_Group%201707481999.png?x-oss-process=image/quality,q_80);
      background-size: cover;

      .awad-task-img {
        margin-right: 0.08rem;

        img.title-word {
          width: 1.2rem;
          height: 0.22rem;
        }
      }

      span.red-big-wrod {
        font-family: DINAlternate-Bold, DINAlternate, sans-serif;
        font-size: 0.18rem;
        font-weight: 700;
        line-height: 0.34rem;
        color: #ff5526;
      }

      span.red-normal {
        color: #ff5526;
      }
    }

    .award-task-container {
      overflow-y: auto;
      background: #fff4ef;
      height: 4.5rem;
      padding-bottom: 0.4rem;
    }

    .award-list {
      margin: 0 0.11rem 0.08rem 0.13rem;
    }

    .task-list {
      margin: 0 0.11rem 0 0.13rem;
    }
  }

  .shadow {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: #000;
    opacity: 0.7;
    z-index: 100;
  }
}
</style>
